var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurrente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.7335,
    height: 65.1923,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 65.1923,
    opacity: 0,
    width: 78.7335,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.787427 32.6047C-0.709567 34.6713-0.0377569 36.6398 2.51036 36.6398L7.01167 36.6398C8.93767 52.4467 22.7359 65.181 39.3948 65.181C48.3695 65.181 56.5176 61.344 62.2236 55.4188C63.9463 53.7968 63.9192 51.5926 62.6508 50.2803C61.3426 48.9085 59.2662 48.744 57.4017 50.3772C52.9058 55.0766 46.5033 58.0201 39.3948 58.0201C26.4853 58.0201 16.107 48.622 14.2847 36.6398L19.0204 36.6398C21.5174 36.6398 22.2191 34.6812 20.7334 32.626L12.9385 21.7331C11.7298 20.0373 9.82234 20.0358 8.60228 21.7331ZM16.5873 9.76215C14.8433 11.3841 14.8803 13.5671 16.1601 14.8694C17.4782 16.2512 19.5233 16.437 21.4092 14.8037C25.9264 10.1356 32.3289 7.16084 39.3948 7.16084C52.283 7.16084 62.6712 16.559 64.5148 28.5625L59.7294 28.5625C57.2224 28.5625 56.5208 30.4997 58.0064 32.5762L65.8114 43.4692C67.02 45.165 68.9275 45.1665 70.1475 43.4692L77.9411 32.5975C79.4494 30.5097 78.7663 28.5625 76.2181 28.5625L71.7878 28.5625C69.8306 12.7556 56.0636 0 39.3948 0C30.42 0 22.3033 3.81564 16.5873 9.76215Z",
    fill: "#28cd41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrente);
export default __webpack_public_path__ + "static/media/recurrente.d84ff209977c5046733c3ed6ab8c579e.svg";
export { ForwardRef as ReactComponent };